import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialBookmark: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 4.57H32v24.38h-1.52Zm-1.53 24.38h1.53v1.53h-1.53Zm0-25.9h1.53v1.52h-1.53ZM3.05 30.48h25.9V32H3.05Zm3.05-6.1h19.81v1.53H6.1Zm0-6.09h19.81v1.52H6.1Zm12.19-6.1h7.62v1.52h-7.62Zm0-4.57h7.62v1.52h-7.62Z\"/><path fill=\"currentColor\" d=\"M7.62 3.05v10.66h1.52v-1.52h1.53v-1.52h1.52v1.52h1.52v1.52h1.53V3.05h13.71V1.52H13.71V0H4.57v1.52H1.52v1.53Zm3.05-1.53h1.52v1.53h1.52V6.1h-1.52V3.05h-1.52ZM1.52 28.95h1.53v1.53H1.52ZM0 3.05h1.52v25.9H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialBookmark
